/* eslint-disable */
/* Code generated by ng-openapi-gen DO NOT EDIT. */

import { HttpClient, HttpContext } from '@angular/common/http';
import { Injectable } from '@angular/core';
import { Observable } from 'rxjs';
import { map } from 'rxjs/operators';

import { BaseService } from '../base-service';
import { ApiConfiguration } from '../api-configuration';
import { StrictHttpResponse } from '../strict-http-response';

import { AccessNumber } from '../models/access-number';
import { AccessNumberListItem } from '../models/access-number-list-item';
import { AccessNumberListItemPagedResult } from '../models/access-number-list-item-paged-result';
import { AccessNumberPagedResult } from '../models/access-number-paged-result';
import { deleteAccessnumberId } from '../fn/access-number/delete-accessnumber-id';
import { DeleteAccessnumberId$Params } from '../fn/access-number/delete-accessnumber-id';
import { getAccessnumber$Json } from '../fn/access-number/get-accessnumber-json';
import { GetAccessnumber$Json$Params } from '../fn/access-number/get-accessnumber-json';
import { getAccessnumber$Plain } from '../fn/access-number/get-accessnumber-plain';
import { GetAccessnumber$Plain$Params } from '../fn/access-number/get-accessnumber-plain';
import { getAccessnumberId$Json } from '../fn/access-number/get-accessnumber-id-json';
import { GetAccessnumberId$Json$Params } from '../fn/access-number/get-accessnumber-id-json';
import { getAccessnumberId$Plain } from '../fn/access-number/get-accessnumber-id-plain';
import { GetAccessnumberId$Plain$Params } from '../fn/access-number/get-accessnumber-id-plain';
import { getAccessnumberMinified$Json } from '../fn/access-number/get-accessnumber-minified-json';
import { GetAccessnumberMinified$Json$Params } from '../fn/access-number/get-accessnumber-minified-json';
import { getAccessnumberMinified$Plain } from '../fn/access-number/get-accessnumber-minified-plain';
import { GetAccessnumberMinified$Plain$Params } from '../fn/access-number/get-accessnumber-minified-plain';
import { getAccessnumberMinifiedV2$Json } from '../fn/access-number/get-accessnumber-minified-v-2-json';
import { GetAccessnumberMinifiedV2$Json$Params } from '../fn/access-number/get-accessnumber-minified-v-2-json';
import { getAccessnumberMinifiedV2$Plain } from '../fn/access-number/get-accessnumber-minified-v-2-plain';
import { GetAccessnumberMinifiedV2$Plain$Params } from '../fn/access-number/get-accessnumber-minified-v-2-plain';
import { postAccessnumber } from '../fn/access-number/post-accessnumber';
import { PostAccessnumber$Params } from '../fn/access-number/post-accessnumber';
import { postAccessnumberMinifiedSearch$Json } from '../fn/access-number/post-accessnumber-minified-search-json';
import { PostAccessnumberMinifiedSearch$Json$Params } from '../fn/access-number/post-accessnumber-minified-search-json';
import { postAccessnumberMinifiedSearch$Plain } from '../fn/access-number/post-accessnumber-minified-search-plain';
import { PostAccessnumberMinifiedSearch$Plain$Params } from '../fn/access-number/post-accessnumber-minified-search-plain';
import { postAccessnumberMinifiedSearchV2$Json } from '../fn/access-number/post-accessnumber-minified-search-v-2-json';
import { PostAccessnumberMinifiedSearchV2$Json$Params } from '../fn/access-number/post-accessnumber-minified-search-v-2-json';
import { postAccessnumberMinifiedSearchV2$Plain } from '../fn/access-number/post-accessnumber-minified-search-v-2-plain';
import { PostAccessnumberMinifiedSearchV2$Plain$Params } from '../fn/access-number/post-accessnumber-minified-search-v-2-plain';
import { postAccessnumberSearch$Json } from '../fn/access-number/post-accessnumber-search-json';
import { PostAccessnumberSearch$Json$Params } from '../fn/access-number/post-accessnumber-search-json';
import { postAccessnumberSearch$Plain } from '../fn/access-number/post-accessnumber-search-plain';
import { PostAccessnumberSearch$Plain$Params } from '../fn/access-number/post-accessnumber-search-plain';
import { putAccessnumberId } from '../fn/access-number/put-accessnumber-id';
import { PutAccessnumberId$Params } from '../fn/access-number/put-accessnumber-id';

@Injectable({ providedIn: 'root' })
export class AccessNumberService extends BaseService {
  constructor(config: ApiConfiguration, http: HttpClient) {
    super(config, http);
  }

  /** Path part for operation `getAccessnumber()` */
  static readonly GetAccessnumberPath = '/accessnumber';

  /**
   * API call to get a specific access number.
   *
   * API call to get a specific access number
   *
   * This method provides access to the full `HttpResponse`, allowing access to response headers.
   * To access only the response body, use `getAccessnumber$Plain()` instead.
   *
   * This method doesn't expect any request body.
   */
  getAccessnumber$Plain$Response(params?: GetAccessnumber$Plain$Params, context?: HttpContext): Observable<StrictHttpResponse<Array<AccessNumber>>> {
    const obs = getAccessnumber$Plain(this.http, this.rootUrl, params, context);
    return obs;
  }

  /**
   * API call to get a specific access number.
   *
   * API call to get a specific access number
   *
   * This method provides access only to the response body.
   * To access the full response (for headers, for example), `getAccessnumber$Plain$Response()` instead.
   *
   * This method doesn't expect any request body.
   */
  getAccessnumber$Plain(params?: GetAccessnumber$Plain$Params, context?: HttpContext): Observable<Array<AccessNumber>> {
    const resp = this.getAccessnumber$Plain$Response(params, context);
    return resp.pipe(
      map((r: StrictHttpResponse<Array<AccessNumber>>): Array<AccessNumber> => r.body)
    );
  }

  /**
   * API call to get a specific access number.
   *
   * API call to get a specific access number
   *
   * This method provides access to the full `HttpResponse`, allowing access to response headers.
   * To access only the response body, use `getAccessnumber$Json()` instead.
   *
   * This method doesn't expect any request body.
   */
  getAccessnumber$Json$Response(params?: GetAccessnumber$Json$Params, context?: HttpContext): Observable<StrictHttpResponse<Array<AccessNumber>>> {
    const obs = getAccessnumber$Json(this.http, this.rootUrl, params, context);
    return obs;
  }

  /**
   * API call to get a specific access number.
   *
   * API call to get a specific access number
   *
   * This method provides access only to the response body.
   * To access the full response (for headers, for example), `getAccessnumber$Json$Response()` instead.
   *
   * This method doesn't expect any request body.
   */
  getAccessnumber$Json(params?: GetAccessnumber$Json$Params, context?: HttpContext): Observable<Array<AccessNumber>> {
    const resp = this.getAccessnumber$Json$Response(params, context);
    return resp.pipe(
      map((r: StrictHttpResponse<Array<AccessNumber>>): Array<AccessNumber> => r.body)
    );
  }

  /** Path part for operation `postAccessnumber()` */
  static readonly PostAccessnumberPath = '/accessnumber';

  /**
   * Creates a new access number.
   *
   * Creates a new access number.
   *
   * This method provides access to the full `HttpResponse`, allowing access to response headers.
   * To access only the response body, use `postAccessnumber()` instead.
   *
   * This method sends `application/*+json` and handles request body of type `application/*+json`.
   */
  postAccessnumber$Response(params?: PostAccessnumber$Params, context?: HttpContext): Observable<StrictHttpResponse<void>> {
    const obs = postAccessnumber(this.http, this.rootUrl, params, context);
    return obs;
  }

  /**
   * Creates a new access number.
   *
   * Creates a new access number.
   *
   * This method provides access only to the response body.
   * To access the full response (for headers, for example), `postAccessnumber$Response()` instead.
   *
   * This method sends `application/*+json` and handles request body of type `application/*+json`.
   */
  postAccessnumber(params?: PostAccessnumber$Params, context?: HttpContext): Observable<void> {
    const resp = this.postAccessnumber$Response(params, context);
    return resp.pipe(
      map((r: StrictHttpResponse<void>): void => r.body)
    );
  }

  /** Path part for operation `getAccessnumberId()` */
  static readonly GetAccessnumberIdPath = '/accessnumber/{id}';

  /**
   * API call to get a specific access number.
   *
   * Retrieves details of an access number by ID.
   *
   * This method provides access to the full `HttpResponse`, allowing access to response headers.
   * To access only the response body, use `getAccessnumberId$Plain()` instead.
   *
   * This method doesn't expect any request body.
   */
  getAccessnumberId$Plain$Response(params: GetAccessnumberId$Plain$Params, context?: HttpContext): Observable<StrictHttpResponse<AccessNumber>> {
    const obs = getAccessnumberId$Plain(this.http, this.rootUrl, params, context);
    return obs;
  }

  /**
   * API call to get a specific access number.
   *
   * Retrieves details of an access number by ID.
   *
   * This method provides access only to the response body.
   * To access the full response (for headers, for example), `getAccessnumberId$Plain$Response()` instead.
   *
   * This method doesn't expect any request body.
   */
  getAccessnumberId$Plain(params: GetAccessnumberId$Plain$Params, context?: HttpContext): Observable<AccessNumber> {
    const resp = this.getAccessnumberId$Plain$Response(params, context);
    return resp.pipe(
      map((r: StrictHttpResponse<AccessNumber>): AccessNumber => r.body)
    );
  }

  /**
   * API call to get a specific access number.
   *
   * Retrieves details of an access number by ID.
   *
   * This method provides access to the full `HttpResponse`, allowing access to response headers.
   * To access only the response body, use `getAccessnumberId$Json()` instead.
   *
   * This method doesn't expect any request body.
   */
  getAccessnumberId$Json$Response(params: GetAccessnumberId$Json$Params, context?: HttpContext): Observable<StrictHttpResponse<AccessNumber>> {
    const obs = getAccessnumberId$Json(this.http, this.rootUrl, params, context);
    return obs;
  }

  /**
   * API call to get a specific access number.
   *
   * Retrieves details of an access number by ID.
   *
   * This method provides access only to the response body.
   * To access the full response (for headers, for example), `getAccessnumberId$Json$Response()` instead.
   *
   * This method doesn't expect any request body.
   */
  getAccessnumberId$Json(params: GetAccessnumberId$Json$Params, context?: HttpContext): Observable<AccessNumber> {
    const resp = this.getAccessnumberId$Json$Response(params, context);
    return resp.pipe(
      map((r: StrictHttpResponse<AccessNumber>): AccessNumber => r.body)
    );
  }

  /** Path part for operation `putAccessnumberId()` */
  static readonly PutAccessnumberIdPath = '/accessnumber/{id}';

  /**
   * Updates details of an access number by ID..
   *
   * Updates details of an access number by ID.
   *
   * This method provides access to the full `HttpResponse`, allowing access to response headers.
   * To access only the response body, use `putAccessnumberId()` instead.
   *
   * This method sends `application/*+json` and handles request body of type `application/*+json`.
   */
  putAccessnumberId$Response(params: PutAccessnumberId$Params, context?: HttpContext): Observable<StrictHttpResponse<void>> {
    const obs = putAccessnumberId(this.http, this.rootUrl, params, context);
    return obs;
  }

  /**
   * Updates details of an access number by ID..
   *
   * Updates details of an access number by ID.
   *
   * This method provides access only to the response body.
   * To access the full response (for headers, for example), `putAccessnumberId$Response()` instead.
   *
   * This method sends `application/*+json` and handles request body of type `application/*+json`.
   */
  putAccessnumberId(params: PutAccessnumberId$Params, context?: HttpContext): Observable<void> {
    const resp = this.putAccessnumberId$Response(params, context);
    return resp.pipe(
      map((r: StrictHttpResponse<void>): void => r.body)
    );
  }

  /** Path part for operation `deleteAccessnumberId()` */
  static readonly DeleteAccessnumberIdPath = '/accessnumber/{id}';

  /**
   * Deletes an access number by ID.
   *
   * Deletes an access number by ID.
   *
   * This method provides access to the full `HttpResponse`, allowing access to response headers.
   * To access only the response body, use `deleteAccessnumberId()` instead.
   *
   * This method doesn't expect any request body.
   */
  deleteAccessnumberId$Response(params: DeleteAccessnumberId$Params, context?: HttpContext): Observable<StrictHttpResponse<void>> {
    const obs = deleteAccessnumberId(this.http, this.rootUrl, params, context);
    return obs;
  }

  /**
   * Deletes an access number by ID.
   *
   * Deletes an access number by ID.
   *
   * This method provides access only to the response body.
   * To access the full response (for headers, for example), `deleteAccessnumberId$Response()` instead.
   *
   * This method doesn't expect any request body.
   */
  deleteAccessnumberId(params: DeleteAccessnumberId$Params, context?: HttpContext): Observable<void> {
    const resp = this.deleteAccessnumberId$Response(params, context);
    return resp.pipe(
      map((r: StrictHttpResponse<void>): void => r.body)
    );
  }

  /** Path part for operation `postAccessnumberSearch()` */
  static readonly PostAccessnumberSearchPath = '/accessnumber/search';

  /**
   * Get a list of the items.
   *
   * Get a list of the items
   *
   * This method provides access to the full `HttpResponse`, allowing access to response headers.
   * To access only the response body, use `postAccessnumberSearch$Plain()` instead.
   *
   * This method sends `application/*+json` and handles request body of type `application/*+json`.
   */
  postAccessnumberSearch$Plain$Response(params?: PostAccessnumberSearch$Plain$Params, context?: HttpContext): Observable<StrictHttpResponse<AccessNumberPagedResult>> {
    const obs = postAccessnumberSearch$Plain(this.http, this.rootUrl, params, context);
    return obs;
  }

  /**
   * Get a list of the items.
   *
   * Get a list of the items
   *
   * This method provides access only to the response body.
   * To access the full response (for headers, for example), `postAccessnumberSearch$Plain$Response()` instead.
   *
   * This method sends `application/*+json` and handles request body of type `application/*+json`.
   */
  postAccessnumberSearch$Plain(params?: PostAccessnumberSearch$Plain$Params, context?: HttpContext): Observable<AccessNumberPagedResult> {
    const resp = this.postAccessnumberSearch$Plain$Response(params, context);
    return resp.pipe(
      map((r: StrictHttpResponse<AccessNumberPagedResult>): AccessNumberPagedResult => r.body)
    );
  }

  /**
   * Get a list of the items.
   *
   * Get a list of the items
   *
   * This method provides access to the full `HttpResponse`, allowing access to response headers.
   * To access only the response body, use `postAccessnumberSearch$Json()` instead.
   *
   * This method sends `application/*+json` and handles request body of type `application/*+json`.
   */
  postAccessnumberSearch$Json$Response(params?: PostAccessnumberSearch$Json$Params, context?: HttpContext): Observable<StrictHttpResponse<AccessNumberPagedResult>> {
    const obs = postAccessnumberSearch$Json(this.http, this.rootUrl, params, context);
    return obs;
  }

  /**
   * Get a list of the items.
   *
   * Get a list of the items
   *
   * This method provides access only to the response body.
   * To access the full response (for headers, for example), `postAccessnumberSearch$Json$Response()` instead.
   *
   * This method sends `application/*+json` and handles request body of type `application/*+json`.
   */
  postAccessnumberSearch$Json(params?: PostAccessnumberSearch$Json$Params, context?: HttpContext): Observable<AccessNumberPagedResult> {
    const resp = this.postAccessnumberSearch$Json$Response(params, context);
    return resp.pipe(
      map((r: StrictHttpResponse<AccessNumberPagedResult>): AccessNumberPagedResult => r.body)
    );
  }

  /** Path part for operation `getAccessnumberMinified()` */
  static readonly GetAccessnumberMinifiedPath = '/accessnumber/minified';

  /**
   * API call to get a specific access number.
   *
   * API call to get a specific access number
   *
   * This method provides access to the full `HttpResponse`, allowing access to response headers.
   * To access only the response body, use `getAccessnumberMinified$Plain()` instead.
   *
   * This method doesn't expect any request body.
   */
  getAccessnumberMinified$Plain$Response(params?: GetAccessnumberMinified$Plain$Params, context?: HttpContext): Observable<StrictHttpResponse<Array<AccessNumberListItem>>> {
    const obs = getAccessnumberMinified$Plain(this.http, this.rootUrl, params, context);
    return obs;
  }

  /**
   * API call to get a specific access number.
   *
   * API call to get a specific access number
   *
   * This method provides access only to the response body.
   * To access the full response (for headers, for example), `getAccessnumberMinified$Plain$Response()` instead.
   *
   * This method doesn't expect any request body.
   */
  getAccessnumberMinified$Plain(params?: GetAccessnumberMinified$Plain$Params, context?: HttpContext): Observable<Array<AccessNumberListItem>> {
    const resp = this.getAccessnumberMinified$Plain$Response(params, context);
    return resp.pipe(
      map((r: StrictHttpResponse<Array<AccessNumberListItem>>): Array<AccessNumberListItem> => r.body)
    );
  }

  /**
   * API call to get a specific access number.
   *
   * API call to get a specific access number
   *
   * This method provides access to the full `HttpResponse`, allowing access to response headers.
   * To access only the response body, use `getAccessnumberMinified$Json()` instead.
   *
   * This method doesn't expect any request body.
   */
  getAccessnumberMinified$Json$Response(params?: GetAccessnumberMinified$Json$Params, context?: HttpContext): Observable<StrictHttpResponse<Array<AccessNumberListItem>>> {
    const obs = getAccessnumberMinified$Json(this.http, this.rootUrl, params, context);
    return obs;
  }

  /**
   * API call to get a specific access number.
   *
   * API call to get a specific access number
   *
   * This method provides access only to the response body.
   * To access the full response (for headers, for example), `getAccessnumberMinified$Json$Response()` instead.
   *
   * This method doesn't expect any request body.
   */
  getAccessnumberMinified$Json(params?: GetAccessnumberMinified$Json$Params, context?: HttpContext): Observable<Array<AccessNumberListItem>> {
    const resp = this.getAccessnumberMinified$Json$Response(params, context);
    return resp.pipe(
      map((r: StrictHttpResponse<Array<AccessNumberListItem>>): Array<AccessNumberListItem> => r.body)
    );
  }

  /** Path part for operation `postAccessnumberMinifiedSearch()` */
  static readonly PostAccessnumberMinifiedSearchPath = '/accessnumber/minified/search';

  /**
   * Get a list of the items.
   *
   * Get a list of the items
   *
   * This method provides access to the full `HttpResponse`, allowing access to response headers.
   * To access only the response body, use `postAccessnumberMinifiedSearch$Plain()` instead.
   *
   * This method sends `application/*+json` and handles request body of type `application/*+json`.
   */
  postAccessnumberMinifiedSearch$Plain$Response(params?: PostAccessnumberMinifiedSearch$Plain$Params, context?: HttpContext): Observable<StrictHttpResponse<AccessNumberListItemPagedResult>> {
    const obs = postAccessnumberMinifiedSearch$Plain(this.http, this.rootUrl, params, context);
    return obs;
  }

  /**
   * Get a list of the items.
   *
   * Get a list of the items
   *
   * This method provides access only to the response body.
   * To access the full response (for headers, for example), `postAccessnumberMinifiedSearch$Plain$Response()` instead.
   *
   * This method sends `application/*+json` and handles request body of type `application/*+json`.
   */
  postAccessnumberMinifiedSearch$Plain(params?: PostAccessnumberMinifiedSearch$Plain$Params, context?: HttpContext): Observable<AccessNumberListItemPagedResult> {
    const resp = this.postAccessnumberMinifiedSearch$Plain$Response(params, context);
    return resp.pipe(
      map((r: StrictHttpResponse<AccessNumberListItemPagedResult>): AccessNumberListItemPagedResult => r.body)
    );
  }

  /**
   * Get a list of the items.
   *
   * Get a list of the items
   *
   * This method provides access to the full `HttpResponse`, allowing access to response headers.
   * To access only the response body, use `postAccessnumberMinifiedSearch$Json()` instead.
   *
   * This method sends `application/*+json` and handles request body of type `application/*+json`.
   */
  postAccessnumberMinifiedSearch$Json$Response(params?: PostAccessnumberMinifiedSearch$Json$Params, context?: HttpContext): Observable<StrictHttpResponse<AccessNumberListItemPagedResult>> {
    const obs = postAccessnumberMinifiedSearch$Json(this.http, this.rootUrl, params, context);
    return obs;
  }

  /**
   * Get a list of the items.
   *
   * Get a list of the items
   *
   * This method provides access only to the response body.
   * To access the full response (for headers, for example), `postAccessnumberMinifiedSearch$Json$Response()` instead.
   *
   * This method sends `application/*+json` and handles request body of type `application/*+json`.
   */
  postAccessnumberMinifiedSearch$Json(params?: PostAccessnumberMinifiedSearch$Json$Params, context?: HttpContext): Observable<AccessNumberListItemPagedResult> {
    const resp = this.postAccessnumberMinifiedSearch$Json$Response(params, context);
    return resp.pipe(
      map((r: StrictHttpResponse<AccessNumberListItemPagedResult>): AccessNumberListItemPagedResult => r.body)
    );
  }

  /** Path part for operation `getAccessnumberMinifiedV2()` */
  static readonly GetAccessnumberMinifiedV2Path = '/accessnumber/minified-v2';

  /**
   * API call to get a specific access number.
   *
   * API call to get a specific access number
   *
   * This method provides access to the full `HttpResponse`, allowing access to response headers.
   * To access only the response body, use `getAccessnumberMinifiedV2$Plain()` instead.
   *
   * This method doesn't expect any request body.
   */
  getAccessnumberMinifiedV2$Plain$Response(params?: GetAccessnumberMinifiedV2$Plain$Params, context?: HttpContext): Observable<StrictHttpResponse<Array<AccessNumberListItem>>> {
    const obs = getAccessnumberMinifiedV2$Plain(this.http, this.rootUrl, params, context);
    return obs;
  }

  /**
   * API call to get a specific access number.
   *
   * API call to get a specific access number
   *
   * This method provides access only to the response body.
   * To access the full response (for headers, for example), `getAccessnumberMinifiedV2$Plain$Response()` instead.
   *
   * This method doesn't expect any request body.
   */
  getAccessnumberMinifiedV2$Plain(params?: GetAccessnumberMinifiedV2$Plain$Params, context?: HttpContext): Observable<Array<AccessNumberListItem>> {
    const resp = this.getAccessnumberMinifiedV2$Plain$Response(params, context);
    return resp.pipe(
      map((r: StrictHttpResponse<Array<AccessNumberListItem>>): Array<AccessNumberListItem> => r.body)
    );
  }

  /**
   * API call to get a specific access number.
   *
   * API call to get a specific access number
   *
   * This method provides access to the full `HttpResponse`, allowing access to response headers.
   * To access only the response body, use `getAccessnumberMinifiedV2$Json()` instead.
   *
   * This method doesn't expect any request body.
   */
  getAccessnumberMinifiedV2$Json$Response(params?: GetAccessnumberMinifiedV2$Json$Params, context?: HttpContext): Observable<StrictHttpResponse<Array<AccessNumberListItem>>> {
    const obs = getAccessnumberMinifiedV2$Json(this.http, this.rootUrl, params, context);
    return obs;
  }

  /**
   * API call to get a specific access number.
   *
   * API call to get a specific access number
   *
   * This method provides access only to the response body.
   * To access the full response (for headers, for example), `getAccessnumberMinifiedV2$Json$Response()` instead.
   *
   * This method doesn't expect any request body.
   */
  getAccessnumberMinifiedV2$Json(params?: GetAccessnumberMinifiedV2$Json$Params, context?: HttpContext): Observable<Array<AccessNumberListItem>> {
    const resp = this.getAccessnumberMinifiedV2$Json$Response(params, context);
    return resp.pipe(
      map((r: StrictHttpResponse<Array<AccessNumberListItem>>): Array<AccessNumberListItem> => r.body)
    );
  }

  /** Path part for operation `postAccessnumberMinifiedSearchV2()` */
  static readonly PostAccessnumberMinifiedSearchV2Path = '/accessnumber/minified/search-v2';

  /**
   * Get a list of the items.
   *
   * Get a list of the items
   *
   * This method provides access to the full `HttpResponse`, allowing access to response headers.
   * To access only the response body, use `postAccessnumberMinifiedSearchV2$Plain()` instead.
   *
   * This method sends `application/*+json` and handles request body of type `application/*+json`.
   */
  postAccessnumberMinifiedSearchV2$Plain$Response(params?: PostAccessnumberMinifiedSearchV2$Plain$Params, context?: HttpContext): Observable<StrictHttpResponse<AccessNumberListItemPagedResult>> {
    const obs = postAccessnumberMinifiedSearchV2$Plain(this.http, this.rootUrl, params, context);
    return obs;
  }

  /**
   * Get a list of the items.
   *
   * Get a list of the items
   *
   * This method provides access only to the response body.
   * To access the full response (for headers, for example), `postAccessnumberMinifiedSearchV2$Plain$Response()` instead.
   *
   * This method sends `application/*+json` and handles request body of type `application/*+json`.
   */
  postAccessnumberMinifiedSearchV2$Plain(params?: PostAccessnumberMinifiedSearchV2$Plain$Params, context?: HttpContext): Observable<AccessNumberListItemPagedResult> {
    const resp = this.postAccessnumberMinifiedSearchV2$Plain$Response(params, context);
    return resp.pipe(
      map((r: StrictHttpResponse<AccessNumberListItemPagedResult>): AccessNumberListItemPagedResult => r.body)
    );
  }

  /**
   * Get a list of the items.
   *
   * Get a list of the items
   *
   * This method provides access to the full `HttpResponse`, allowing access to response headers.
   * To access only the response body, use `postAccessnumberMinifiedSearchV2$Json()` instead.
   *
   * This method sends `application/*+json` and handles request body of type `application/*+json`.
   */
  postAccessnumberMinifiedSearchV2$Json$Response(params?: PostAccessnumberMinifiedSearchV2$Json$Params, context?: HttpContext): Observable<StrictHttpResponse<AccessNumberListItemPagedResult>> {
    const obs = postAccessnumberMinifiedSearchV2$Json(this.http, this.rootUrl, params, context);
    return obs;
  }

  /**
   * Get a list of the items.
   *
   * Get a list of the items
   *
   * This method provides access only to the response body.
   * To access the full response (for headers, for example), `postAccessnumberMinifiedSearchV2$Json$Response()` instead.
   *
   * This method sends `application/*+json` and handles request body of type `application/*+json`.
   */
  postAccessnumberMinifiedSearchV2$Json(params?: PostAccessnumberMinifiedSearchV2$Json$Params, context?: HttpContext): Observable<AccessNumberListItemPagedResult> {
    const resp = this.postAccessnumberMinifiedSearchV2$Json$Response(params, context);
    return resp.pipe(
      map((r: StrictHttpResponse<AccessNumberListItemPagedResult>): AccessNumberListItemPagedResult => r.body)
    );
  }

}
